import packages from './linkBuildingPackages.json' with { type: 'json' };
import nicheTerms from './pricingNicheTerms.json' with { type: 'json' };

export const companyFacts = {
  founder: 'Marija Smilkova',
  experienceYearsMinimum: 8,
  services: ['link building', 'guest posts', 'white label link building', 'AEO/GEO'],
  niches: ['SaaS', 'fintech', 'B2B', 'ecommerce', 'education', 'insurance', 'iGaming', 'crypto'],
  manualOutreach: true,
  usesPBNs: false,
};
export const starterSummary = `${packages[0].links} links for $${packages[0].price.toLocaleString('en-US')}, ${packages[0].deliveryWeeks.join(' to ')} weeks`;
export const nicheNote = `${nicheTerms.notePrefix}${nicheTerms.quoteLabel}.`;
export const companyFactLines = [
  `Founded by ${companyFacts.founder}`,
  `${companyFacts.experienceYearsMinimum}+ years in link building, partnerships and outreach`,
  `Services: ${companyFacts.services.join(', ')}`,
  `Niches: ${companyFacts.niches.join(', ')}`,
  `Starter: ${starterSummary}`,
  'Manual outreach on real publishers, no PBNs',
];
const escapeHtml = value => String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
export const companyFactsHtml = () => `<section data-company-facts><h2>Linkzy at a glance</h2><ul>${companyFactLines.map(line => `<li>${escapeHtml(line)}</li>`).join('')}</ul><p>${escapeHtml(nicheNote)}</p></section>`;